import HouseLevel0 from 'public/assets/illustrations/level_house_0.png';
import HouseLevel1 from 'public/assets/illustrations/level_house_1.png';
import HouseLevel2 from 'public/assets/illustrations/level_house_2.png';
import HouseLevel3 from 'public/assets/illustrations/level_house_3.png';
import HouseLevel4 from 'public/assets/illustrations/level_house_4.png';
import HouseLevel5 from 'public/assets/illustrations/level_house_5.png';
import HouseLevel6 from 'public/assets/illustrations/level_house_6.png';

export const getCorrectIllustration = (sharesAmount?: number) => {
  if (sharesAmount === undefined) {
    return;
  }

  switch (true) {
    case sharesAmount === 0:
      return HouseLevel0;
    case sharesAmount < 100:
      return HouseLevel1;
    case sharesAmount < 500:
      return HouseLevel2;
    case sharesAmount < 1000:
      return HouseLevel3;
    case sharesAmount < 5000:
      return HouseLevel4;
    case sharesAmount < 10000:
      return HouseLevel5;
    case sharesAmount > 10000:
      return HouseLevel6;
    default:
      return HouseLevel0;
  }
};
